<template>
  <router-view/>
</template>

<script>
export default {
  name: "Admin",
  data() {
    return {
      msg: "Welcome to IQ Hub Admin"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/Admin.vue